export default __webpack_public_path__ + "static/dot-pattern-1d58a55f951662b48d14584bdf72a308.svg";